import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { SearchService } from '../../../../shared/services/search.service';
import { CommonSvgIconComponent } from '../../common-svg-icon/common-svg-icon.component';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { ClickOutsideDirective } from '../../../directive/click-outside.directive';
import { Products } from '../../../../models/product.model';
import { ProductService } from '../../../services/products/product.service';

@Component({
    selector: 'app-search',
    imports: [FormsModule, RouterModule, CommonSvgIconComponent, CommonModule, ClickOutsideDirective],
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})

export class SearchComponent {

  public productList: Products[]=[];
  public text: string;
  public searchResult = false;
  public searchResultEmpty = false;
  private sortFilter:string;

  constructor( public searchService : SearchService,private _router:Router,
    private _productService:ProductService){ }


  findProducts(value:string){
    value ? this.addFix() : this.removeFix();
    if (!value) return (this.productList = []);
    this._productService.filter(value,this.sortFilter,undefined,8).subscribe({
      next: (response) => {
        this.checkSearchResultEmpty(response.data);
        this.productList=response.data;
        this.text=value;
      },
      error: ({error}) => {
      },
    })

    return;
  }
  

  checkSearchResultEmpty(items: Products[]) {
    if (!items.length) this.searchResultEmpty = true;
    else this.searchResultEmpty = false;
  }

  addFix() {
    this.searchResult = true;
    document.body.classList.add("offcanvas");
  }

  clickOutside(): void {
    this.text = "";
    this.searchResult = false;
    this.searchResultEmpty = false;
    document.body.classList.remove("offcanvas");
  }

  removeFix() {
    this.text = "";
    this.searchResult = false;
    document.body.classList.remove("offcanvas");
  }
  redirectToSearch({value}:any){
    window.scrollTo(0, 0);
    this._router.navigate(["/search"],{ queryParams: { search: value } })
  }
}
